// extracted by mini-css-extract-plugin
module.exports = {"noOrdersContainer":"RecallHistory-noOrdersContainer-1zQr-","listSelected":"RecallHistory-listSelected-32fiG","listNotSelected":"RecallHistory-listNotSelected-3GsUj"};